exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageLoader__spinner {\n  padding-top: 20%;\n  padding-bottom: 20%;\n  text-align: center;\n}\n.PageLoader__spinner .fa {\n  font-size: 30px;\n}\n.PageLoader__spinner .fa,\n.PageLoader__content {\n  opacity: 0;\n  transition: opacity 0.25s ease-in-out;\n}\n.PageLoader__spinner .fa.visible,\n.PageLoader__content.visible {\n  opacity: 1;\n}\n", ""]);

// exports
